var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBraggingTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1737_875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2735 2.75928L8.2735 0.0586096C8.18755 0.0199756 8.09439 0 8.00017 0C7.90594 0 7.81278 0.0199756 7.72683 0.0586096L1.72683 2.75928C1.60966 2.81195 1.5102 2.89735 1.44042 3.00522C1.37064 3.11308 1.33351 3.23881 1.3335 3.36728V9.60794C1.33295 10.0827 1.43185 10.5524 1.62383 10.9866C1.81581 11.4209 2.09662 11.8101 2.44817 12.1293L5.7815 15.1426C6.38873 15.6943 7.17973 16 8.00017 16C8.8206 16 9.6116 15.6943 10.2188 15.1426L13.5522 12.1293C13.9037 11.8101 14.1845 11.4209 14.3765 10.9866C14.5685 10.5524 14.6674 10.0827 14.6668 9.60794V3.36728C14.6668 3.23881 14.6297 3.11308 14.5599 3.00522C14.4901 2.89735 14.3907 2.81195 14.2735 2.75928ZM11.1402 6.47128L7.80683 9.80461C7.68181 9.92959 7.51228 9.9998 7.3355 9.9998C7.15872 9.9998 6.98918 9.92959 6.86417 9.80461L4.86417 7.80461C4.74273 7.67887 4.67553 7.51047 4.67705 7.33568C4.67857 7.16088 4.74868 6.99367 4.87229 6.87006C4.99589 6.74646 5.1631 6.67635 5.3379 6.67483C5.5127 6.67331 5.6811 6.7405 5.80683 6.86194L7.3335 8.39061L10.1955 5.52861C10.3212 5.40717 10.4896 5.33997 10.6644 5.34149C10.8392 5.34301 11.0064 5.41312 11.13 5.53673C11.2536 5.66034 11.3238 5.82754 11.3253 6.00234C11.3268 6.17714 11.2596 6.34554 11.1382 6.47128H11.1402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1737_875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraggingTabIcon);
export default __webpack_public_path__ + "static/media/Bragging_tab_icon.21ebc242da19897d1bf848f621b37554.svg";
export { ForwardRef as ReactComponent };